// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Pt1J","colCheckbox":"styles_colCheckbox__ig7YN"};